import { render, staticRenderFns } from "./completion.vue?vue&type=template&id=0526f8d0&scoped=true&"
import script from "./completion.vue?vue&type=script&lang=js&"
export * from "./completion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0526f8d0",
  null
  
)

export default component.exports